import Modal from "react-modal";

import { CloseModalIcon } from "../CloseModalIcon";

const ImagePreviewModal = ({
  imgSrc,
  isOpen,
  onRequestClose,
}: {
  imgSrc: string;
  isOpen: boolean;
  onRequestClose: () => void;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="imagePreviewModal"
    >
      <CloseModalIcon onRequestClose={onRequestClose} />
      <div className="imagePreviewWrapper">
        <img src={imgSrc} alt="" width="100%" className="imagePreview" />
      </div>
    </Modal>
  );
};

export default ImagePreviewModal;
